

// console.log("shared worker manger is working...")

export const tabSharedWorker = new SharedWorker(
  new URL('./sharedWorker.ts', import.meta.url),
  { type: 'module' }
);

tabSharedWorker.port.start();
